import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ArchiveBoxArrowDownIcon,
  BoltIcon,
  BuildingOffice2Icon,
  CreditCardIcon,
  DocumentArrowUpIcon,
  InboxArrowDownIcon,
  TagIcon,
  UserCircleIcon,
  UsersIcon,
} from "@heroicons/react/20/solid";
import TeamToggle from "../../components/TeamToggle";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navigation({ groups, setView, view }) {
  const navigate = useNavigate();

  const [selectedTab, setSelectedTab] = useState(null);
  let location = useLocation();
  const tabGroups = [
    {
      title: "Your account",
      tabs: [
        {
          name: "Profile",
          href: "/settings",
          current: false,
          icon: <UserCircleIcon className="w-3 text-gray-400" />,
        },
      ],
    },
    {
      title: "Inboxes",
      tabs: [
        {
          name: "Team inboxes",
          href: "/settings/inboxes",
          current: true,
          icon: <InboxArrowDownIcon className="w-3 text-gray-400" />,
        },
        //  { name: 'Sent', href: '/sent', current: false },
        // { name: 'Drafts', href: '/drafts', current: false }
      ],
    },
    {
      title: "Organization",
      tabs: [
        {
          name: "Users",
          href: "/settings/users",
          current: true,
          icon: <UsersIcon className="w-3 text-gray-400" />,
        },
        {
          name: "Organization settings",
          href: "/settings/organization",
          current: true,
          icon: <BuildingOffice2Icon className="w-3 text-gray-400" />,
        },
        {
          name: "Billing",
          href: "/settings/billing",
          current: true,
          icon: <CreditCardIcon className="w-3 text-gray-400" />,
        },
        //  { name: 'Sent', href: '/sent', current: false },
        // { name: 'Drafts', href: '/drafts', current: false }
      ],
    },
  ];

  useEffect(() => {
    // If it changes to one of the tabs
    const allTabs = tabGroups.flatMap((group) => group.tabs);
    const activeTab = allTabs.find((tab) => location.pathname === tab.href);
    setSelectedTab(activeTab);
  }, [location]);

  return (
    <div className="mt-8 flex flex-col h-full ">
      <div className="space-y-8">
        {tabGroups?.map((tabGroup) => (
          <div>
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
              <select
                id="tabs"
                name="tabs"
                onChange={(e) => setView(e.target.value)}
                className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
                defaultValue={""}
              >
                {tabGroup?.tabs?.map((tab) => (
                  <option key={tab.name}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav className="" aria-label="Tabs">
                <h1 className="px-3 text-xs font-semibold mb-2">
                  {tabGroup.title}
                </h1>
                {tabGroup?.tabs?.map((tab) => (
                  <div
                    key={tab.name}
                    href={tab.href}
                    onClick={(e) => {
                      // Optimistically update selected tab
                      setSelectedTab(tab.href);
                      navigate(tab.href);
                    }}
                    className={classNames(
                      tab.href == location.pathname
                        ? " text-gray-600 bg-white rounded-xl pl-3 pr-3 py-2 font-medium"
                        : " px-3 text-gray-500 hover:text-gray-700",
                      "py-2 text-xs flex items-center justify-between cursor-pointer hover:bg-gray-50"
                    )}
                    aria-current={tab.name == view ? "page" : undefined}
                  >
                    <div className="flex items-center space-x-2">
                      {tab.icon}
                      <p>{tab.name}</p>
                    </div>
                  </div>
                ))}
              </nav>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
